// Keyboard-only focus ring helper (adds .user-is-tabbing to <body> after Tab key)
// Keeps focus outlines hidden for mouse/touch clicks, but visible for keyboard users.
// Also prevents iOS/Safari from showing a native focus ring on the mobile menu close button after a tap.
(function () {
  var lastInput = 'pointer';

  function setKeyboardMode() {
    document.body.classList.add('user-is-tabbing');
    lastInput = 'keyboard';
    window.removeEventListener('keydown', onKeyDown, true);
  }

  function unsetKeyboardMode() {
    document.body.classList.remove('user-is-tabbing');
    lastInput = 'pointer';
  }

  function onKeyDown(e) {
    // Tab or Shift+Tab
    if (e.key === 'Tab' || e.keyCode === 9) setKeyboardMode();
  }

  window.addEventListener('keydown', onKeyDown, true);
  window.addEventListener('mousedown', unsetKeyboardMode, true);
  window.addEventListener('touchstart', unsetKeyboardMode, true);

  // iOS/Safari sometimes focuses the close button when the drawer opens, which can show a blue ring.
  // If the drawer was opened via touch/click (not keyboard), immediately blur that element.
  function blurAutoFocusedCloseButton() {
    try {
      var active = document.activeElement;
      if (!active) return;
      if (document.body.classList.contains('user-is-tabbing')) return;
      if (active.classList && active.classList.contains('menu-drawer__close-button')) {
        active.blur();
      }
    } catch (e) {}
  }

  document.addEventListener(
    'toggle',
    function (e) {
      var el = e.target;
      if (!el || el.tagName !== 'DETAILS') return;
      if (!el.classList || !el.classList.contains('menu-drawer-container')) return;
      if (!el.open) return;
      if (lastInput !== 'pointer') return;

      // Let Shopify/Dawn move focus first, then remove it
      setTimeout(blurAutoFocusedCloseButton, 0);
      setTimeout(blurAutoFocusedCloseButton, 50);
    },
    true
  );
})();
